import { artifacts as artifacts$1 } from '@thema/core';
export { SetType } from '@thema/core';
import SolanaTokenSetArtifact from '@thema/core/solanaArtifacts/token_set.json';
import UniswapV3Factory_Artifact from '@uniswap/v3-core/artifacts/contracts/UniswapV3Factory.sol/UniswapV3Factory.json';
import UniswapV3Pool_Artifact from '@uniswap/v3-core/artifacts/contracts/UniswapV3Pool.sol/UniswapV3Pool.json';
import UniswapV3SwapRouter_Artifact from '@uniswap/v3-periphery/artifacts/contracts/SwapRouter.sol/SwapRouter.json';
import UniswapV3SwapRouter02_Artifact from '@uniswap/swap-router-contracts/artifacts/contracts/SwapRouter02.sol/SwapRouter02.json';
import UniswapV3Quoter_Artifact from '@uniswap/v3-periphery/artifacts/contracts/lens/Quoter.sol/Quoter.json';
import UniswapV3QuoterV2_Artifact from '@uniswap/v3-periphery/artifacts/contracts/lens/QuoterV2.sol/QuoterV2.json';
import UniswapV3PositionManager_Artifact from '@uniswap/v3-periphery/artifacts/contracts/NonfungiblePositionManager.sol/NonfungiblePositionManager.json';

var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var UniswapV3FactoryArtifact = UniswapV3Factory_Artifact;
var UniswapV3PoolArtifact = UniswapV3Pool_Artifact;
var UniswapV3SwapRouterArtifact = UniswapV3SwapRouter_Artifact;
var UniswapV3SwapRouter02Artifact = UniswapV3SwapRouter02_Artifact;
var UniswapV3QuoterArtifact = UniswapV3Quoter_Artifact;
var UniswapV3QuoterV2Artifact = UniswapV3QuoterV2_Artifact;
var UniswapV3PositionManagerArtifact = UniswapV3PositionManager_Artifact;
var artifacts = {
  // Core contract artifacts
  ...artifacts$1,
  // Add aliases for backward compatibility
  TestThemaOracle: artifacts$1.TestThemaOracle,
  SwapAndMintOMTL: artifacts$1.SwapAndMintOMT,
  // Note: In core it's SwapAndMintOMT, this alias might be intentional or a typo
  OMTPriceFeed: artifacts$1.OMTPriceFeed,
  // External artifacts
  SolanaTokenSet: SolanaTokenSetArtifact,
  UniswapV3Factory: UniswapV3FactoryArtifact,
  UniswapV3Pool: UniswapV3PoolArtifact,
  UniswapV3SwapRouter: UniswapV3SwapRouterArtifact,
  UniswapV3SwapRouter02: UniswapV3SwapRouter02Artifact,
  UniswapV3Quoter: UniswapV3QuoterArtifact,
  UniswapV3QuoterV2: UniswapV3QuoterV2Artifact,
  UniswapV3PositionManager: UniswapV3PositionManagerArtifact
  // Ensure WETH9 is available, it should come from coreArtifacts
  // WETH9: coreArtifacts.WETH9 if not already spread
  // WETH9Artifact: coreArtifacts.WETH9Artifact if not already spread
};

// src/ui/deployments/generated/index.ts
var deployments = [
  {
    "id": "manta/manta1/tMantaBNB",
    "displayName": "tMantaBNB on BSC",
    "chains": [
      "56"
    ],
    "users": [
      {
        "name": "deployer",
        "role": "deploy",
        "address": "0x3B84aB36DEf9C51C5dAFC99801C19DCf2c0C169B"
      },
      {
        "name": "treasury",
        "role": "recipient",
        "address": "0x919BfCf61b1992461Ffb908370284Dbf2B9a8aA6"
      },
      {
        "name": "revshare",
        "role": "recipient",
        "address": "0xFB2741c2c9c6eaa79507d2021DC9A90D1F1e2125"
      },
      {
        "name": "lpfees",
        "role": "recipient",
        "address": "0xD7E57a48300ED5dB587162A7e829EC296B199724"
      },
      {
        "name": "liqfund",
        "role": "liquidity",
        "address": "0x59c46513f8e61e789C294033eCdE84329fa60D87"
      },
      {
        "name": "arbbot",
        "role": "arb",
        "address": "0xB2f3ef5Adf92B9c66a14123745D9249a49e27d7d"
      }
    ],
    "chainDeployments": {
      "56": {
        "chainId": "56",
        "rpcUrl": "https://bnb-mainnet.g.alchemy.com/v2/RBpL5MGWMousasUNUEB83",
        "addressMap": {
          "USDT": "0x55d398326f99059fF775485246999027B3197955",
          "WBNB": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
          "tMantaBNB": "0xd5bf07ae3728aa7fe8902b49f5d2c63b772b39c4"
        },
        "chainlinkPriceFeeds": {
          "USDT": "0xB97Ad0E74fa7d920791E90258A6E2085088b4320",
          "WBNB": "0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE",
          "tMantaBNB": "0x7e479e13bcca69a170223a8f7263a8f0142508f8"
        },
        "tokens": {
          "0x55d398326f99059fF775485246999027B3197955": {
            "address": "0x55d398326f99059fF775485246999027B3197955",
            "symbol": "USDT",
            "name": "Tether USD",
            "decimals": 18
          },
          "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c": {
            "address": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
            "symbol": "WBNB",
            "name": "Wrapped BNB",
            "decimals": 18
          }
        },
        "omts": {
          "0xd5bf07ae3728aa7fe8902b49f5d2c63b772b39c4": {
            "address": "0xd5bf07ae3728aa7fe8902b49f5d2c63b772b39c4",
            "symbol": "tMantaBNB",
            "name": "Thema Manta Wrapped BNB",
            "decimals": 18,
            "components": [
              {
                "token": {
                  "address": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
                  "symbol": "WBNB",
                  "name": "Wrapped BNB",
                  "decimals": 18
                },
                "quantity": "1"
              }
            ],
            "vaults": {
              "@clvault": {
                "kind": "cl",
                "label": "TMNTA-BNB/USDT Vault",
                "custody": "0x59c46513f8e61e789C294033eCdE84329fa60D87",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDT",
                    "address": "0x55d398326f99059fF775485246999027B3197955",
                    "decimals": 18,
                    "ratio": 0.5
                  }
                ]
              }
            }
          }
        }
      }
    },
    "defaultChainId": "56",
    "omtDeploymentBlock": 77947597
  },
  {
    "id": "thema/thema-dev/tbtc01",
    "displayName": "TBTC01 on Base",
    "chains": [
      "8453"
    ],
    "users": [
      {
        "name": "adminsafe",
        "role": "safe",
        "address": "0xF246EB1D9a089Fd76Ea729D9a5F5e66A0D088B84"
      },
      {
        "name": "beta5MigrationHolder",
        "role": "user",
        "address": "0x5b0d89d609780A7890De1A300bA1184Edf58929D"
      },
      {
        "name": "safefund",
        "role": "safe",
        "address": "0x7167fe8787E3A35257520C2796fd4D6A0CD11A4B"
      },
      {
        "name": "safetbtc",
        "role": "liquidity",
        "address": "0x774F1036b9573228f030b4DfBC70ca3F39ee84fc"
      },
      {
        "name": "safetbtcLp",
        "role": "liquidity",
        "address": "0xFb232681b3eA9aB1fEe8083CE1a003C75cdd3d50"
      },
      {
        "name": "safetbtcLp2",
        "role": "liquidity",
        "address": "0x472F2583533f97634d626cB4647AdDf88b4032A7"
      },
      {
        "name": "safetbtcLp3",
        "role": "liquidity",
        "address": "0x827ad8ff0BC5A9aF188cAb8e446D8BF41526F461"
      },
      {
        "name": "safetbtcLp4",
        "role": "liquidity",
        "address": "0x086746a3a7e77eE37f4CF84Bc529Ef303ae79b92"
      },
      {
        "name": "safetbtcLp5",
        "role": "liquidity",
        "address": "0x05fEeeA431173479e3C1Da6D102FfdaC2a30E71D"
      },
      {
        "name": "deployer",
        "role": "deploy",
        "address": "0x3Bfd461AbA6971DFB42f38686796b6Ff3901B24D"
      },
      {
        "name": "treasury",
        "role": "recipient",
        "address": "0x919BfCf61b1992461Ffb908370284Dbf2B9a8aA6"
      },
      {
        "name": "revshare",
        "role": "recipient",
        "address": "0xFB2741c2c9c6eaa79507d2021DC9A90D1F1e2125"
      },
      {
        "name": "aamir_admin",
        "role": "admin",
        "address": "0x3023ef79e575695e02e0ab983c16d62047bc45c9"
      },
      {
        "name": "brian_admin",
        "role": "admin",
        "address": "0xD86876058f050A3Aa6D1c15F5D7182d22CC0aaf1"
      },
      {
        "name": "brian_admin_20260507",
        "role": "admin",
        "address": "0xFA024894C93d35c349F121498EE89C207e629274"
      },
      {
        "name": "aditya_admin_20260507",
        "role": "admin",
        "address": "0x73c52C1D92faF4EB923d216840715f9c4F174BF0"
      },
      {
        "name": "ateet_admin",
        "role": "admin",
        "address": "0x69e4D5437aB82a02ccB58211360ace8149655D59"
      },
      {
        "name": "liqfund",
        "role": "liquidity",
        "address": "0x27e75911fa3634eaa532a65891dd70b5430469c6"
      },
      {
        "name": "arbbot",
        "role": "arb",
        "address": "0x4b3e4111ea7e37156c5ceed2829d8f976a688dbf"
      }
    ],
    "chainDeployments": {
      "8453": {
        "chainId": "8453",
        "rpcUrl": "https://base-mainnet.g.alchemy.com/v2/QxfVVboGXQ_rg3580s1TIJCNZTkQzoRh",
        "addressMap": {
          "USDC": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
          "cbBTC": "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
          "WETH": "0x4200000000000000000000000000000000000006",
          "TBTC01": "0x395e2cd3fba0da8818613e4e661ca83eac3f888c"
        },
        "chainlinkPriceFeeds": {
          "USDC": "0x7e860098F58bBFC8648a4311b374B1D669a2bc6B",
          "cbBTC": "0xCCADC697c55bbB68dc5bCdf8d3CBe83CdD4E071E",
          "WETH": "0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70",
          "TBTC01": "0xa7cdd67db48ffd4aea10a28cdcc8714f40ba5567"
        },
        "tokens": {
          "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913": {
            "address": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
            "symbol": "USDC",
            "name": "USD Coin",
            "decimals": 6
          },
          "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf": {
            "address": "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
            "symbol": "cbBTC",
            "name": "Coinbase Bitcoin",
            "decimals": 8
          },
          "0x4200000000000000000000000000000000000006": {
            "address": "0x4200000000000000000000000000000000000006",
            "symbol": "WETH",
            "name": "Wrapped Ether",
            "decimals": 18
          }
        },
        "omts": {
          "0x395e2cd3fba0da8818613e4e661ca83eac3f888c": {
            "address": "0x395e2cd3fba0da8818613e4e661ca83eac3f888c",
            "symbol": "TBTC01",
            "name": "Thema Bitcoin 01",
            "decimals": 18,
            "components": [
              {
                "token": {
                  "address": "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
                  "symbol": "cbBTC",
                  "name": "Coinbase Bitcoin",
                  "decimals": 8
                },
                "quantity": "1"
              }
            ],
            "vaults": {
              "@clvault": {
                "kind": "cl",
                "label": "TBTC01/USDC Vault",
                "custody": "0x27e75911fa3634eaa532a65891dd70b5430469c6",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDC",
                    "address": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
                    "decimals": 6,
                    "ratio": 0.5
                  }
                ]
              },
              "@safeclvault": {
                "kind": "cl",
                "label": "TBTC01/USDC Safe Vault",
                "custody": "0x774F1036b9573228f030b4DfBC70ca3F39ee84fc",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDC",
                    "address": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
                    "decimals": 6,
                    "ratio": 0.5
                  }
                ]
              },
              "@safetbtcLp5": {
                "kind": "cl",
                "label": "TBTC01/USDC LP-backed Safe Vault Beta 5",
                "custody": "0x05fEeeA431173479e3C1Da6D102FfdaC2a30E71D",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDC",
                    "address": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
                    "decimals": 6,
                    "ratio": 0.5
                  }
                ]
              },
              "@arb-wallet": {
                "kind": "cl",
                "label": "Arb Bot Wallet",
                "custody": "0x4b3e4111ea7e37156c5ceed2829d8f976a688dbf",
                "assetSet": [
                  {
                    "symbol": "USDC",
                    "address": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
                    "decimals": 6,
                    "ratio": 1
                  }
                ]
              },
              "@beta6Vault": {
                "kind": "lp",
                "address": "0x714fdf230478F59573ef62Cce74cAaEB75896f7E",
                "label": "Thema cbBTC LP Vault Beta 6",
                "stablecoin": {
                  "symbol": "cbBTC",
                  "address": "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
                  "decimals": 8
                },
                "accountingBase": {
                  "symbol": "USDC",
                  "address": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
                  "decimals": 6
                },
                "safe": "0x05fEeeA431173479e3C1Da6D102FfdaC2a30E71D",
                "depositCap": 1e5,
                "defaultWalletCap": 100,
                "name": "Thema cbBTC LP Vault Beta 6",
                "vaultSymbol": "tbtc01-vault-beta6",
                "enabled": true,
                "lifecycle": "active",
                "roles": {
                  "admin": [
                    "@ateet_admin",
                    "@aamir_admin"
                  ]
                },
                "migration": {
                  "shareCap": 1e3,
                  "blacklist": [],
                  "recipients": [
                    "@beta5MigrationHolder",
                    "@ateet_admin"
                  ],
                  "sources": {
                    "@beta5Vault": {
                      "exchangeRate": 1,
                      "chainId": "8453",
                      "address": "0x0C5a6bb743Ba3544EbD34DCB1493c71Fc86442E9"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "defaultChainId": "8453",
    "omtDeploymentBlock": 42977351
  },
  {
    "id": "thema/thema-dev/themaOP",
    "displayName": "themaOP on Optimism",
    "chains": [
      "10"
    ],
    "users": [
      {
        "name": "deployer",
        "role": "deploy",
        "address": "0x4Dd6dbA99e5B93b982754EC7eDF56fF88140DD03"
      },
      {
        "name": "tenderAgent",
        "role": "liquidity",
        "address": "0x8d25d049618EC9d70E3Ec6A4A3fb7888C7307F61"
      },
      {
        "name": "arbAgent",
        "role": "eoa",
        "address": "0xdd8a014166b1047ee5d107C82FDA094927A7d4F7"
      },
      {
        "name": "adminsafe",
        "role": "safe",
        "address": "0x4083f84C4a6F40362Ad7640F2731C8c44b2E7DE9"
      },
      {
        "name": "safeopLp",
        "role": "liquidity",
        "address": "0x4e975572323E9f07c24b04A1957FceBe4C120BDe"
      },
      {
        "name": "themaOPOwner",
        "role": "safe",
        "address": "0x02995aad56F683454945Ec06Af86cfCfA07332d2"
      },
      {
        "name": "treasury",
        "role": "recipient",
        "address": "0x919BfCf61b1992461Ffb908370284Dbf2B9a8aA6"
      },
      {
        "name": "revshare",
        "role": "recipient",
        "address": "0xFB2741c2c9c6eaa79507d2021DC9A90D1F1e2125"
      },
      {
        "name": "aamir_admin",
        "role": "admin",
        "address": "0x3023ef79e575695e02e0ab983c16d62047bc45c9"
      },
      {
        "name": "brian_admin",
        "role": "admin",
        "address": "0xD86876058f050A3Aa6D1c15F5D7182d22CC0aaf1"
      },
      {
        "name": "brian_admin_20260507",
        "role": "admin",
        "address": "0xFA024894C93d35c349F121498EE89C207e629274"
      },
      {
        "name": "aditya_admin_20260507",
        "role": "admin",
        "address": "0x73c52C1D92faF4EB923d216840715f9c4F174BF0"
      },
      {
        "name": "ateet_admin",
        "role": "admin",
        "address": "0x69e4D5437aB82a02ccB58211360ace8149655D59"
      },
      {
        "name": "liqfund",
        "role": "liquidity",
        "address": "0x27e75911fa3634eaa532a65891dd70b5430469c6"
      },
      {
        "name": "arbbot",
        "role": "arb",
        "address": "0x4b3e4111ea7e37156c5ceed2829d8f976a688dbf"
      }
    ],
    "chainDeployments": {
      "10": {
        "chainId": "10",
        "rpcUrl": "https://mainnet.optimism.io",
        "addressMap": {
          "USDC": "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
          "OP": "0x4200000000000000000000000000000000000042",
          "WETH": "0x4200000000000000000000000000000000000006",
          "themaOP": "0xda7030b555c3016b1f3233a56019db8cbb713b5a"
        },
        "chainlinkPriceFeeds": {
          "USDC": "0x16a9fa2fda030272ce99b29cf780dfa30361e0f3",
          "OP": "0x0D276FC14719f9292D5C1eA2198673d1f4269246",
          "WETH": "0x13e3Ee699D1909E989722E753853AE30b17e08c5",
          "themaOP": "0x8eef0635328837760d063a3be4725d96bdaec9b3"
        },
        "tokens": {
          "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85": {
            "address": "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
            "symbol": "USDC",
            "name": "USD Coin",
            "decimals": 6
          },
          "0x4200000000000000000000000000000000000042": {
            "address": "0x4200000000000000000000000000000000000042",
            "symbol": "OP",
            "name": "Optimism",
            "decimals": 18
          },
          "0x4200000000000000000000000000000000000006": {
            "address": "0x4200000000000000000000000000000000000006",
            "symbol": "WETH",
            "name": "Wrapped Ether",
            "decimals": 18
          }
        },
        "omts": {
          "0xda7030b555c3016b1f3233a56019db8cbb713b5a": {
            "address": "0xda7030b555c3016b1f3233a56019db8cbb713b5a",
            "symbol": "themaOP",
            "name": "Thema Optimism",
            "decimals": 18,
            "components": [
              {
                "token": {
                  "address": "0x4200000000000000000000000000000000000042",
                  "symbol": "OP",
                  "name": "Optimism",
                  "decimals": 18
                },
                "quantity": "1"
              }
            ],
            "vaults": {
              "@deployerSeedVault": {
                "kind": "cl",
                "label": "themaOP/USDC Deployer Seed",
                "custody": "0x4Dd6dbA99e5B93b982754EC7eDF56fF88140DD03",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDC",
                    "address": "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
                    "decimals": 6,
                    "ratio": 0.5
                  }
                ]
              },
              "@safeopLpVault": {
                "kind": "cl",
                "label": "themaOP/USDC LP Safe Vault",
                "custody": "0x4e975572323E9f07c24b04A1957FceBe4C120BDe",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDC",
                    "address": "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
                    "decimals": 6,
                    "ratio": 0.5
                  }
                ]
              },
              "@themaBeta4OPVault": {
                "kind": "lp",
                "address": "0x574b60dB99b205aAbbE36bAFE81290b6206eb8D3",
                "label": "themaBeta4OP Vault",
                "stablecoin": {
                  "symbol": "OP",
                  "address": "0x4200000000000000000000000000000000000042",
                  "decimals": 18
                },
                "accountingBase": {
                  "symbol": "USDC",
                  "address": "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
                  "decimals": 6
                },
                "safe": "0x4e975572323E9f07c24b04A1957FceBe4C120BDe",
                "depositCap": 4e3,
                "defaultWalletCap": 0,
                "name": "themaBeta4OP Vault",
                "vaultSymbol": "themaOP-vault-beta4-mast",
                "enabled": true,
                "lifecycle": "active",
                "roles": {
                  "admin": [
                    "@ateet_admin",
                    "@aamir_admin"
                  ]
                },
                "migration": {
                  "shareCap": 500,
                  "blacklist": [],
                  "recipients": [
                    "@deployer",
                    "@themaOPOwner"
                  ],
                  "sources": {
                    "@themaBeta3OPVault": {
                      "exchangeRate": 1,
                      "chainId": "10",
                      "address": "0x8CFD9a664d8eDE1ABb90738649B0d7Df4018b406"
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "defaultChainId": "10",
    "omtDeploymentBlock": 152938980
  },
  {
    "id": "thema/thema-dev/tmwbnb04",
    "displayName": "TMWBNB04 on BSC",
    "chains": [
      "56"
    ],
    "users": [
      {
        "name": "adminsafe",
        "role": "safe",
        "address": "0x8345e4B74B68c5290F00b6057ac91093B31998BD"
      },
      {
        "name": "deployer",
        "role": "deploy",
        "address": "0x3Bfd461AbA6971DFB42f38686796b6Ff3901B24D"
      },
      {
        "name": "treasury",
        "role": "recipient",
        "address": "0x919BfCf61b1992461Ffb908370284Dbf2B9a8aA6"
      },
      {
        "name": "revshare",
        "role": "recipient",
        "address": "0xFB2741c2c9c6eaa79507d2021DC9A90D1F1e2125"
      },
      {
        "name": "aamir_admin",
        "role": "admin",
        "address": "0x3023ef79e575695e02e0ab983c16d62047bc45c9"
      },
      {
        "name": "brian_admin",
        "role": "admin",
        "address": "0xD86876058f050A3Aa6D1c15F5D7182d22CC0aaf1"
      },
      {
        "name": "brian_admin_20260507",
        "role": "admin",
        "address": "0xFA024894C93d35c349F121498EE89C207e629274"
      },
      {
        "name": "aditya_admin_20260507",
        "role": "admin",
        "address": "0x73c52C1D92faF4EB923d216840715f9c4F174BF0"
      },
      {
        "name": "ateet_admin",
        "role": "admin",
        "address": "0x69e4D5437aB82a02ccB58211360ace8149655D59"
      },
      {
        "name": "liqfund",
        "role": "liquidity",
        "address": "0x27e75911fa3634eaa532a65891dd70b5430469c6"
      },
      {
        "name": "arbbot",
        "role": "arb",
        "address": "0x4b3e4111ea7e37156c5ceed2829d8f976a688dbf"
      }
    ],
    "chainDeployments": {
      "56": {
        "chainId": "56",
        "rpcUrl": "https://bnb-mainnet.g.alchemy.com/v2/RBpL5MGWMousasUNUEB83",
        "addressMap": {
          "USDT": "0x55d398326f99059fF775485246999027B3197955",
          "WBNB": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
          "TMWBNB04": "0x498458546a75c8fcb6ff8cce8ec0bf4f15492f98"
        },
        "chainlinkPriceFeeds": {
          "USDT": "0xB97Ad0E74fa7d920791E90258A6E2085088b4320",
          "WBNB": "0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE"
        },
        "tokens": {
          "0x55d398326f99059fF775485246999027B3197955": {
            "address": "0x55d398326f99059fF775485246999027B3197955",
            "symbol": "USDT",
            "name": "Tether USD",
            "decimals": 18
          },
          "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c": {
            "address": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
            "symbol": "WBNB",
            "name": "Wrapped BNB",
            "decimals": 18
          }
        },
        "omts": {
          "0x498458546a75c8fcb6ff8cce8ec0bf4f15492f98": {
            "address": "0x498458546a75c8fcb6ff8cce8ec0bf4f15492f98",
            "symbol": "TMWBNB04",
            "name": "BNB TMA Wrapped BNB",
            "decimals": 18,
            "components": [
              {
                "token": {
                  "address": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
                  "symbol": "WBNB",
                  "name": "Wrapped BNB",
                  "decimals": 18
                },
                "quantity": "1"
              }
            ],
            "vaults": {
              "@clvault": {
                "kind": "cl",
                "label": "TMWBNB04/USDT Vault",
                "custody": "0x27e75911fa3634eaa532a65891dd70b5430469c6",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDT",
                    "address": "0x55d398326f99059fF775485246999027B3197955",
                    "decimals": 18,
                    "ratio": 0.5
                  }
                ]
              }
            }
          }
        }
      }
    },
    "defaultChainId": "56"
  },
  {
    "id": "thema/thema-dev/tmwbnb05",
    "displayName": "TMWBNB05 on BSC",
    "chains": [
      "56"
    ],
    "users": [
      {
        "name": "deployer",
        "role": "deploy",
        "address": "0x3Bfd461AbA6971DFB42f38686796b6Ff3901B24D"
      },
      {
        "name": "treasury",
        "role": "recipient",
        "address": "0x919BfCf61b1992461Ffb908370284Dbf2B9a8aA6"
      },
      {
        "name": "revshare",
        "role": "recipient",
        "address": "0xFB2741c2c9c6eaa79507d2021DC9A90D1F1e2125"
      },
      {
        "name": "aamir_admin",
        "role": "admin",
        "address": "0x3023ef79e575695e02e0ab983c16d62047bc45c9"
      },
      {
        "name": "brian_admin",
        "role": "admin",
        "address": "0xD86876058f050A3Aa6D1c15F5D7182d22CC0aaf1"
      },
      {
        "name": "brian_admin_20260507",
        "role": "admin",
        "address": "0xFA024894C93d35c349F121498EE89C207e629274"
      },
      {
        "name": "aditya_admin_20260507",
        "role": "admin",
        "address": "0x73c52C1D92faF4EB923d216840715f9c4F174BF0"
      },
      {
        "name": "ateet_admin",
        "role": "admin",
        "address": "0x69e4D5437aB82a02ccB58211360ace8149655D59"
      },
      {
        "name": "liqfund",
        "role": "liquidity",
        "address": "0x27e75911fa3634eaa532a65891dd70b5430469c6"
      },
      {
        "name": "arbbot",
        "role": "arb",
        "address": "0x4b3e4111ea7e37156c5ceed2829d8f976a688dbf"
      }
    ],
    "chainDeployments": {
      "56": {
        "chainId": "56",
        "rpcUrl": "https://bnb-mainnet.g.alchemy.com/v2/RBpL5MGWMousasUNUEB83",
        "addressMap": {
          "USDT": "0x55d398326f99059fF775485246999027B3197955",
          "WBNB": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
          "TMWBNB05": "0x13d7f506c675fec794ad56c0299f1d916d8c9296"
        },
        "chainlinkPriceFeeds": {
          "USDT": "0xB97Ad0E74fa7d920791E90258A6E2085088b4320",
          "WBNB": "0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE",
          "TMWBNB05": "0x8a06e45f915c59686facfd6992d541c09ba0baa2"
        },
        "tokens": {
          "0x55d398326f99059fF775485246999027B3197955": {
            "address": "0x55d398326f99059fF775485246999027B3197955",
            "symbol": "USDT",
            "name": "Tether USD",
            "decimals": 18
          },
          "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c": {
            "address": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
            "symbol": "WBNB",
            "name": "Wrapped BNB",
            "decimals": 18
          }
        },
        "omts": {
          "0x13d7f506c675fec794ad56c0299f1d916d8c9296": {
            "address": "0x13d7f506c675fec794ad56c0299f1d916d8c9296",
            "symbol": "TMWBNB05",
            "name": "BNB TMA Wrapped BNB",
            "decimals": 18,
            "components": [
              {
                "token": {
                  "address": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
                  "symbol": "WBNB",
                  "name": "Wrapped BNB",
                  "decimals": 18
                },
                "quantity": "1"
              }
            ],
            "vaults": {
              "@clvault": {
                "kind": "cl",
                "label": "TMWBNB05/USDT Vault",
                "custody": "0x27e75911fa3634eaa532a65891dd70b5430469c6",
                "pool": "@pool",
                "assetSet": [
                  {
                    "symbol": "USDT",
                    "address": "0x55d398326f99059fF775485246999027B3197955",
                    "decimals": 18,
                    "ratio": 0.5
                  }
                ]
              }
            }
          }
        }
      }
    },
    "defaultChainId": "56",
    "omtDeploymentBlock": 77249526
  }
];
function getDeployments() {
  return deployments;
}
function getDeploymentById(id) {
  return deployments.find((d) => d.id === id);
}
function getChains() {
  const chainSet = /* @__PURE__ */ new Set();
  deployments.forEach((d) => d.chains.forEach((c) => chainSet.add(c)));
  return Array.from(chainSet).sort();
}
function getChainsForDeployment(deploymentId) {
  return getDeploymentById(deploymentId)?.chains ?? [];
}
function getDefaultChainId(deploymentId) {
  return getDeploymentById(deploymentId)?.defaultChainId;
}
function getRpcUrl(deploymentId, chainId) {
  const deployment = getDeploymentById(deploymentId);
  if (!deployment) return void 0;
  const targetChainId = chainId ?? deployment.defaultChainId;
  return deployment.chainDeployments[targetChainId]?.rpcUrl;
}
function getOmtDeploymentBlock(deploymentId) {
  return getDeploymentById(deploymentId)?.omtDeploymentBlock;
}

// src/ui/deployments/selectors.ts
var CHAIN_WRAPPED_NATIVE = {
  "1": "WETH",
  "56": "WBNB",
  "137": "WMATIC",
  "3441006": "WETH",
  // Manta Pacific
  "8453": "WETH",
  // Base
  "42161": "WETH",
  // Arbitrum
  "10": "WETH"
  // Optimism
};
var CHAIN_OMT_SIGN_TOKEN = {
  "56": {
    "tMantaBNB": "WBNB"
  },
  //bsc
  "8453": {
    "TBTC01": "cbBTC"
  },
  // Base
  "10": {
    "themaOP": "OP"
  }
  // Optimism
};
function getWrappedTokenNameforChain(chainId, omtSymbol) {
  if (omtSymbol) {
    return CHAIN_OMT_SIGN_TOKEN[chainId]?.[omtSymbol] ?? "WETH";
  }
  return CHAIN_WRAPPED_NATIVE[chainId] ?? "WETH";
}
function listDeployments() {
  return getDeployments();
}
function getDeployment(deploymentId) {
  return getDeploymentById(deploymentId);
}
function getChains2() {
  return getChains();
}
function getDeploymentChains(deploymentId) {
  return getChainsForDeployment(deploymentId);
}
function getDefaultChain(deploymentId) {
  return getDefaultChainId(deploymentId);
}
function getRpcUrl2(deploymentId, chainId) {
  return getRpcUrl(deploymentId, chainId);
}
function getOmtDeploymentStartBlock(deploymentId) {
  return getOmtDeploymentBlock(deploymentId);
}
function getOMT(chainId, omtAddress) {
  return getOMTDeploymentInfo(chainId, omtAddress);
}
function getOMTDeploymentInfo(chainId, omtAddress) {
  const addr = omtAddress.toLowerCase();
  const deployments2 = getDeployments();
  for (const deployment of deployments2) {
    const chainData = deployment.chainDeployments[chainId];
    if (!chainData?.omts) continue;
    const omts = chainData.omts;
    const entry = omts[omtAddress] ?? Object.values(omts).find((omt) => omt.address?.toLowerCase() === addr);
    if (entry) return entry;
  }
  return null;
}
function hasDeployment(deploymentId) {
  return getDeploymentById(deploymentId) !== void 0;
}
function isChainSupported(deploymentId, chainId) {
  const chains = getChainsForDeployment(deploymentId);
  return chains.includes(chainId);
}

export { __require, artifacts, deployments, getChains2 as getChains, getDefaultChain, getDeployment, getDeploymentChains, getOMT, getOMTDeploymentInfo, getOmtDeploymentStartBlock, getRpcUrl2 as getRpcUrl, getWrappedTokenNameforChain, hasDeployment, isChainSupported, listDeployments };
//# sourceMappingURL=chunk-7G6YSIZR.mjs.map
//# sourceMappingURL=chunk-7G6YSIZR.mjs.map